import React from 'react';
import HomeContent from '../../components/homeContent';
import Page from '../../components/page';
import 'antd/dist/antd.css';

export default function HomePage() {
    return (
        <Page hideFooter={true} hideHeaderBg={true}>
            <HomeContent />
        </Page>
    );
}